<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <fieldset>
    <legend>
      {{ $t('Add your business details') }}
    </legend>

    <BusinessEntityInput
      v-model="companyNo"
      :disabled="disabled"
      :label="$t('Company registration number')"
      name="company_no"
    >
      <CompanyNumberTooltip class="m-l-5" market="UK" />
    </BusinessEntityInput>
    <BusinessEntityInput
      v-model="registeredCompanyName"
      :disabled="disabled"
      :label="$t('Business name')"
      name="registered_company_name"
    />

    <BusinessEntityVat
      v-model:business-entity="internalBusinessEntity"
      :compliance-data="complianceData"
      :disabled="disabled"
    />
  </fieldset>
</template>

<script>
/* eslint-disable import-x/extensions */
import BusinessEntityInput from '@/components/compliances/BusinessEntity/BusinessEntityInput.vue'
import BusinessEntityVat from '@/components/compliances/BusinessEntity/BusinessEntityVat.vue'
import CompanyNumberTooltip from '@/components/compliances/BusinessEntity/CompanyNumberTooltip.vue'
import { deepClone } from '@/utils/tools'

export default {
  components: {
    BusinessEntityInput,
    BusinessEntityVat,
    CompanyNumberTooltip,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    complianceData: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    freelancer: {
      type: Object,
      required: true,
    },
  },
  data() {
    const internalBusinessEntity = deepClone(this.businessEntity)
    return {
      internalBusinessEntity,
    }
  },
  computed: {
    companyNo: {
      get() {
        return this.internalBusinessEntity.companyNo
      },
      set(companyNo) {
        this.internalBusinessEntity.companyNo = companyNo
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
    registeredCompanyName: {
      get() {
        return this.internalBusinessEntity.companyName
      },
      set(registeredCompanyName) {
        this.internalBusinessEntity.companyName = registeredCompanyName
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
  },
}
</script>
